import { DEFAULT_OPERATION_CODES } from './roles';
import { OperationCode } from './types';

interface OperationScope {
  prefix: string;
  operations: OperationCode[];
}

const OPERATION_SCOPES: OperationScope[] = [
  { prefix: '/admin/aquisicao', operations: ['serraria', 'industria'] },
  { prefix: '/admin/producao', operations: ['serraria', 'industria'] },
  { prefix: '/admin/qualidade', operations: ['serraria', 'industria'] },
  { prefix: '/admin/estoque', operations: ['serraria', 'industria'] },
  { prefix: '/admin/movimento', operations: ['serraria', 'industria'] },
  { prefix: '/admin/manutencao', operations: ['serraria', 'industria'] },
  { prefix: '/admin/pessoas', operations: ['gestao'] },
  { prefix: '/admin/indicadores', operations: ['serraria', 'industria', 'gestao', 'logistica'] },
  { prefix: '/admin/parametros', operations: ['serraria', 'industria', 'gestao'] },
  { prefix: '/admin/logistica', operations: ['logistica'] },
];

export const resolveOperationsForPath = (path: string): OperationCode[] => {
  const normalized = path.startsWith('/') ? path : `/${path}`;
  const scope = OPERATION_SCOPES.find((item) => normalized.startsWith(item.prefix));
  return scope?.operations ?? DEFAULT_OPERATION_CODES;
};
